import { useTranslation } from 'react-i18next'
import type { WeeklyGmvEvolution } from 'core/api/home/weekly-gmv'
import WidgetErrorCard from 'components/common/cards/widget-error-card'
import WeeklyGmvChart from './weekly-gmv-chart'

interface WeeklyGmvSectionProps {
  weeklyGmv?: WeeklyGmvEvolution | null
  currency: string
}

const WeeklyGmvSection = ({ weeklyGmv, currency }: WeeklyGmvSectionProps) => {
  const { t } = useTranslation()

  return (
    <div className="mg-weekly-gmv-section">
      <div className="mg-weekly-gmv-section-title vp-subtitle-m">{t('general.homepage.weekly-gmv-chart.title')}</div>
      {weeklyGmv?.weeks.length ? (
        <WeeklyGmvChart weeklyGmvPoints={weeklyGmv.weeks} currency={currency} />
      ) : (
        <WidgetErrorCard titleKey="general.homepage.weekly-gmv-chart.error-title" testId="weekly-gmv-chart-error" />
      )}
    </div>
  )
}

export default WeeklyGmvSection
